import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { errorPixService } from "../services/error-pix";

export const errorPixKeys = {
  all: ["errorPix"] as const,
  list: (dbName: string) => [...errorPixKeys.all, "list", dbName] as const,
};

export function useErrorPixData(dbName: string) {
  return useQuery({
    queryKey: errorPixKeys.list(dbName),
    queryFn: async () => {
      if (!dbName) return null;
      const response = await errorPixService.getErrorPixData(dbName);
      return response.data;
    },
    enabled: !!dbName,
    staleTime: 1000 * 60 * 20,
    gcTime: 1000 * 60 * 30,
    refetchInterval: 1000 * 60 * 20,
  });
}

export function useDownloadErrorPixMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (dbName: string) => {
      const response = await errorPixService.downloadErrorPixFiles(dbName);
      return response.data;
    },
    onSuccess: (_, dbName) => {
      queryClient.invalidateQueries({
        queryKey: errorPixKeys.list(dbName),
      });
    },
  });
}
